
<form [formGroup]="formGroup">
    <p-accordion #accordion>
        <p-accordionTab [header]="'dynamic-form.configuration.general' | translate" formGroupName="general"
            [selected]="true" [transitionOptions]="'100ms'">
    
            <div class="grid formgrid p-fluid">
    
    
                <div *ngFor="let page of fc.Pages; let i = index" class="field col-12">
                    <button pButton (click)="fc.Form.deletePage(i)"
                        [label]="('dynamic-form.configuration.borrar-pagina' | translate ) + page.name" icon="pi pi-trash"
                        class="p-button-danger button-edit p-button-outlined"></button>
                </div>
    
            </div>
    
        </p-accordionTab>
    </p-accordion>
</form>